import React, {Component} from 'react';
import i18n from "../../i18n";
import {YesNoModal} from "../elements/YesNoModal";
import {ChannelLogo} from "../channels/ChannelLogo";
import {AddClientAdAccountButtonWithModal} from "../client/ad_accounts/AddClientAdAccountButtonWithModal";

export class UnlinkedAdAccountRow extends Component {
    constructor(props) {
        super(props);
        this.handleSnoozeForever = this.handleSnoozeForever.bind(this);

        this.state = {
            isSaving: this.props.isSaving,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSaving !== this.props.isSaving) {
            this.setState({isSaving: this.props.isSaving});
        }
    }

    handleSnoozeForever() {
        this.props.onSnoozeForever(this.props.adAccount.id)
    }

    render() {
        return (
            <tr key={this.props.adAccount.id}>
                <td style={{paddingLeft: '0.4em'}}>
                    {this.renderAccountColumnText()}
                </td>
                <td>
                    <div className="some-icons">
                        <div>
                            <AddClientAdAccountButtonWithModal channel={this.props.adAccount.channel}
                                                               adAccountId={this.props.adAccount.account_id}
                                                               afterSuccessfulSubmit={this.props.onAssignToClient}
                                                               adAccountIsAlreadySelected={true}
                                                               buttonClassName={""}
                                                               buttonText={""}
                                                               buttonTitle="Vincular cuenta publicitaria a cliente"
                                                               buttonIconName={"plus-square"}
                                                               hasAgentModule={this.props.hasAgentModule}
                            />
                        </div>
                        <div style={{marginLeft: "5px"}}>
                            <YesNoModal onYesAnswer={this.handleSnoozeForever}
                                        title={i18n.t('unlinked_ad_account.ignore_title')}
                                        message={i18n.t('unlinked_ad_account.ignore_message')}
                                        question={i18n.t('unlinked_ad_account.ignore_question')}
                                        buttonClassName={""}
                                        buttonText={""}
                                        buttonTitle="Ignorar cuenta publicitaria"
                                        buttonIconName={"minus-square"}
                                        isSaving={this.state.isSaving}
                                        isOpen={this.props.loadIgnoreModal}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} height={"20px"} marginLeft={"0px"} width={"20px"} channel={this.props.adAccount.channel}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.adAccount.account_id}<br/>{this.props.adAccount.name}
                </span>
            </div>
        )
    }
}
